import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './scripts/app'; // Adjust path if needed

function useAuthRedirect() {
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) { // Only redirect after loading is complete
      if (currentUser) {
        console.log("Authenticated, redirecting to main hub");
        navigate('/main/launchpad');
      } else {
        console.log("Not authenticated, redirecting to login");
        navigate('/login');
      }
    }
  }, [currentUser, loading, navigate]);
}

export default useAuthRedirect;
